<app-details-page-header
  [title]="'admin.legalEntityRole.new' | translate"
  (back)="goBack()"
></app-details-page-header>

<!-- Main content -->
<div class="card card-details shadow-sm border-0 py-2">
  <div>
    <h5 class="px-4 pt-2">
      {{ "admin.common.tabs.details" | translate }}
    </h5>
    <app-details-tab
      [formGroupInput]="databaseManagementFormGroup.controls.details"
      [showButtons]="false"
      [disableCodeInput]="false"
      [disableSave]="databaseManagementFormGroup.invalid"
    ></app-details-tab>
    <hr class="border border-secondary border-1 opacity-50 mx-4 mb-4 mt-0" />
  </div>

  <div>
    <h5 class="px-4 pt-2">
      {{ "admin.common.tabs.localizations" | translate }}
    </h5>
    <app-localization-tab
      [formGroupInput]="databaseManagementFormGroup.controls.localizationsTab"
      [showButtons]="false"
      [disableSave]="databaseManagementFormGroup.invalid"
    ></app-localization-tab>
  </div>

  <div class="d-flex justify-content-end gap-2 px-4 py-4">
    <app-button
      [label]="'general.cancel' | translate"
      variant="default"
      (clicked)="goBack()"
    />
    <app-button
      [iconClass]="'fas fa-add'"
      [label]="'general.add' | translate"
      btnClass="btn btn-primary btn-sm action-btn"
      (clicked)="save()"
      [disabled]="databaseManagementFormGroup.invalid"
    />
  </div>
</div>
